import { CameraIcon } from '@radix-ui/react-icons';
import { IconButton } from '@radix-ui/themes';
import { NotifyHelper } from 'classes/helpers/notify.helper';
import { ErrorBoundary } from 'components/common/error-boundary';
import { MachineContext } from 'contexts/machine.context';
import { StaticVideoType, WsMsgType } from 'lib_ts/enums/machine-msg.enum';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { Nullable } from 'lib_ts/interfaces/common/i-generics';
import { DEFAULT_MACHINE_STATE } from 'lib_ts/interfaces/i-machine-state';
import { IPreviewVideoMsg } from 'lib_ts/interfaces/machine-msg/i-preview-video';
import { useContext } from 'react';
import { WebSocketService } from 'services/web-socket.service';

const COMPONENT_NAME = 'VideoPreviewButton';

export const VideoPreviewButton = (props: {
  videoID: Nullable<string>;
  px: number | undefined;
  pz: number | undefined;
  disabled?: boolean;
}) => {
  const { resetMSHash } = useContext(MachineContext);

  return (
    <ErrorBoundary identifier={COMPONENT_NAME}>
      <IconButton
        size="1"
        title="Preview video using the machine's projector."
        className="btn-floating"
        variant={RADIX.BUTTON.VARIANT.BORDERLESS}
        color={RADIX.COLOR.NEUTRAL}
        disabled={props.disabled}
        onClick={() => {
          if (!props.videoID) {
            NotifyHelper.warning({
              message_md: 'Please select a video to preview first.',
            });
            return;
          }

          const safePx = props.px ?? DEFAULT_MACHINE_STATE.px;
          const safePz = props.pz ?? DEFAULT_MACHINE_STATE.pz;

          const data: IPreviewVideoMsg = {
            px: safePx,
            pz: safePz,
            video_uuid:
              props.videoID ??
              (safePx > 0
                ? StaticVideoType.default_LHP
                : StaticVideoType.default_RHP),
          };

          WebSocketService.send(
            WsMsgType.U2M_PreviewVideo,
            data,
            COMPONENT_NAME
          );

          resetMSHash();
        }}
      >
        <CameraIcon />
      </IconButton>
    </ErrorBoundary>
  );
};
